
import SideBar from "@/components/SideBar/SideBar.vue";
export default {
  components: { SideBar },
};
